// Dashboard request function (the centralized service layer; FRONTEND_RULES §9).
// Pure async over the shared client — no Redux, no React. The dashboard slice
// reads /dashboard via apiGet directly today; this wrapper exists so other slices
// (e.g. portfolio, which composes /dashboard for cross-screen summary data) reuse
// one definition.

import { apiGet } from './client';

/**
 * GET /dashboard?accountId= — the dashboard payload for one account (balance,
 * growth breakdown, projections, contributions, activity).
 * @param {string} accountId e.g. "ACC-P001-ACME"
 */
export function getDashboard(accountId) {
  return apiGet(`/dashboard?accountId=${encodeURIComponent(accountId)}`);
}

/**
 * GET /dashboard/readiness?accountId=&retirementAge= — one readiness projection at a
 * chosen retirement age. The page load ships only the default age; the card fetches
 * each other age when it is picked (one iJoin call per age, cached server-side).
 * @param {string} accountId e.g. "ACC-P001-ACME"
 * @param {number|string} retirementAge e.g. 67
 */
export function getReadinessProjection(accountId, retirementAge) {
  return apiGet(
    `/dashboard/readiness?accountId=${encodeURIComponent(accountId)}&retirementAge=${encodeURIComponent(retirementAge)}`,
  );
}

/**
 * GET /dashboard/distributions/{requestId}?accountId= — the "View details" record for
 * one of the account's distribution requests: its payments and, for a loan, the
 * amortization schedule. 404 when the request is not one of the account's own.
 * @param {string} accountId e.g. "ACC-P001-ACME"
 * @param {string} requestId the tracker row's `requestId`
 */
export function getDistributionDetails(accountId, requestId) {
  return apiGet(
    `/dashboard/distributions/${encodeURIComponent(requestId)}?accountId=${encodeURIComponent(accountId)}`,
  );
}
